import {
  Column,
  DataGrid,
  FilterRow,
  Item,
  Toolbar,
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import { CustomStore, DataSource } from "devextreme/common/data";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getUserProjects } from "../../api/users";
import { AdministratorPanelUser } from "../../types";

type UserProjectsPopupProps = {
  user: AdministratorPanelUser;
  onClose: () => void;
};

export default function UserProjectsPopup({
  user,
  onClose,
}: UserProjectsPopupProps) {
  const { t } = useTranslation();

  const dataSource = useMemo(() => {
    return new DataSource({
      store: new CustomStore({
        loadMode: "raw",
        key: "id",
        load: async () => await getUserProjects(user.id),
      }),
    });
  }, [user.id]);

  return (
    <Popup
      visible
      title={t("administrationPanel.userProjectsPopup.header", {
        fullName: `${user.lastName} ${user.firstName}`,
      })}
      onHiding={onClose}
      maxWidth={800}
      height="auto"
      maxHeight="80vh"
      showCloseButton
      dragEnabled
    >
      <DataGrid
        dataSource={dataSource}
        showBorders
        allowColumnResizing
        allowColumnReordering
        searchPanel={{
          visible: true,
          placeholder: t("searchPlaceholder"),
        }}
        paging={{
          pageSize: 10,
        }}
        pager={{
          visible: true,
          showInfo: true,
          showNavigationButtons: true,
        }}
      >
        <Toolbar>
          <Item
            name="searchPanel"
            location="before"
            locateInMenu="auto"
            cssClass="datagrid-search-panel-without-margin-left"
          />
        </Toolbar>
        <FilterRow visible />
        <Column
          dataField="companyName"
          dataType="string"
          caption={t("project.companyName")}
          width={300}
        />
        <Column
          dataField="acronym"
          dataType="string"
          caption={t("project.acronym")}
        />
      </DataGrid>
    </Popup>
  );
}
